import { getProps, setDataSet } from './utils'

import type { VTooltipOption } from './types'
import type { Directive } from 'vue'

export const vTooltip: Directive<HTMLElement, VTooltipOption['content'] | VTooltipOption> = {
  mounted(el, { value }) {
    if (!value) {
      return
    }
    setDataSet(el, getProps(value))
  },
  updated(el, { value }) {
    if (!value) {
      return
    }
    setDataSet(el, getProps(value))
  }
  // beforeUnmount(el) {}
}

export default vTooltip
